import {Component, Input, Output, OnInit, EventEmitter, SimpleChanges, OnChanges} from '@angular/core';
import {OAuthService} from 'angular-oauth2-oidc';
import {ClientService} from '../services/client.service';
import {CommunicationsService} from '../services/communications.service';
import {NgFor, NgIf} from '@angular/common';
import {MatChipsModule} from '@angular/material/chips';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {PrivacyDialogComponent} from '../privacy-dialog/privacy-dialog.component';
import {FmcLibraryNotificationService} from '../services/notification.service';

@Component({
  selector: 'fmc-phone-dialog',
  templateUrl: './phone-dialog.component.html',
  styleUrls: ['./phone-dialog.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    NgFor,
    MatChipsModule,
    MatButtonModule,
    MatIconModule,
    PrivacyDialogComponent
  ]
})
export class PhoneDialogComponent implements OnInit, OnChanges {
  @Input() vxLook: string;
  @Input() recipients: any[];
  @Input() appId: number;
  @Input() leadId: number;
  @Input() entityType: number;
  @Input() phoneEnabled = false;
  @Output() public closeDialog = new EventEmitter<any>();
  public userDetails: any;
  public activeCaller: any = null;
  public activePhoneNumber: any = null;
  public recipientsContactList = [];

  constructor(private oauthService: OAuthService,
              public clientService: ClientService,
              public notificationService: FmcLibraryNotificationService,
              public communicationService: CommunicationsService) {
  }

  public ngOnInit(): void {
    this.userDetails = this.oauthService.getIdentityClaims();
    this.setupDefaults();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.borrowers && !changes.borrowers.currentValue) {
      this.recipientsContactList = [];
      this.activeCaller = null;
      this.activePhoneNumber = null;
    } else if (changes && changes.borrowers && changes.borrowers.currentValue !== changes.borrowers.previousValue && !changes.borrowers.firstChange) {
      this.recipientsContactList = [];
      this.setupDefaults();
      this.activeCaller = null;
      this.activePhoneNumber = null;
    }
  }

  private setupDefaults(): void {
    if (!this.recipients?.length) {
      return;
    }

    this.recipients.forEach(recipient => {
      const partyId = (recipient.PrimaryContactPartyID) ? recipient.PrimaryContactPartyID : (recipient.party && recipient.party.party) ? recipient.party.party.iD : (recipient.party && recipient.party.iD) ? recipient.party.iD : (recipient.PartyID) ? recipient.PartyID : null;
      this.clientService.getPartyPhoneList(partyId)
        .subscribe(data => {
          this.pushPhoneNumber(recipient, data);
        });
    });
  }

  public pushPhoneNumber(recipient, data) {
    console.log('recipient', recipient);

    const contact = {
      'name': '',
      'phoneNumbers' : [],
      'recipient': recipient
    };

    if (recipient.person) {
      contact.name = recipient.person.firstName + ' ' + recipient.person.lastName;
    } else if (recipient.company) {
      contact.name = recipient.company.companyName;
    } else if (recipient.trust) {
      contact.name = recipient.trust.trustName;
    } else if (recipient.party && recipient.party.party && recipient.party.party.name) {
      contact.name = recipient.party.party.name;
    } else if (recipient.PartyName) {
      contact.name = recipient.PartyName;
    }

    data.forEach( phone => {
      if (phone.TelephoneTypeID === 3) {
        if (!this.recipientsContactList.find(x => x.phoneNumber === phone.TelephoneNumber.telephoneNumber)) {
          contact.phoneNumbers.push({'type': 'mobile', 'number': phone.TelephoneNumber.telephoneNumber});
        }
      }

      if (phone.TelephoneTypeID === 1) {
        if (!this.recipientsContactList.find(x => x.phoneNumber === phone.TelephoneNumber.telephoneNumber)) {
          contact.phoneNumbers.push({'type': 'fixed', 'number': phone.TelephoneNumber.telephoneNumber});
        }
      }
    });

    this.recipientsContactList.push(contact);
  }

  public makeCall(recipient, phoneNumber): void {
    try {
      console.log('this.userDetails makeCall', this.userDetails);
      console.log('recipient makeCall', recipient, phoneNumber);

      if (this.userDetails && this.userDetails.phone_extension) {
        const recipientData = recipient?.recipient;
        const idv = (recipientData?.partyRoleId) ?
          recipientData.partyRoleId : (recipientData?.partyRoleData) ?
            recipientData.partyRoleData?.iD : (recipientData?.PrimaryContactPartyRoleID) ?
              recipientData?.PrimaryContactPartyRoleID : (recipientData?.PartyRoleID) ?
                recipientData?.PartyRoleID : null;

        const data = {
          from: this.userDetails.phone_extension,
          to: phoneNumber,
          idt: 'crumbs-party-role',
          idv: idv
        };

        this.activeCaller = recipient;
        this.activePhoneNumber = phoneNumber;
        console.log(this.activeCaller);

        if (this.phoneEnabled) {
          this.communicationService.makePhoneCall('type', this.appId, data)
            .subscribe(response => {
                console.log(response);
              },
              error => {
                console.log(error);
              });
        }
      } else {
        this.notificationService.notify('warn', 'You do not have phone extension to make this call', 'Warning');
      }
    } catch (e) {
      console.error(e);
    }
  }

  endCall() {
    this.activeCaller = null;
    this.activePhoneNumber = null;
  }
}

